module.exports = __webpack_public_path__ + "img/history12.f9588e20.jpg";